export default __webpack_public_path__ + "static/media/down.54711c75.svg";